import { v4 as uuid } from 'uuid';
export class ReplyController {
    static $inject = ['BuilderContentService', 'RepliesService', 'SegmentService', 'application', '$stateParams', 'ngToast', '$translate', 'SavingService', '$timeout', 'PermissionsService'];
    constructor(BuilderContentService, RepliesService, SegmentService, application, $stateParams, ngToast, $translate, SavingService, $timeout, PermissionsService) {
        'ngInject';
        this.BuilderContentService = BuilderContentService;
        this.RepliesService = RepliesService;
        this.SegmentService = SegmentService;
        this.application = application;
        this.$stateParams = $stateParams;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.SavingService = SavingService;
        this.$timeout = $timeout;
        this.PermissionsService = PermissionsService;
        this.items = [];
        this.repeatedTitlesErrorMsg = '';
        this.contenSentSuccessMsg = '';
    }
    sortReplies(a, b) {
        try {
            const textA = a.name.toLowerCase();
            const textB = b.name.toLowerCase();
            if (textA < textB) {
                return -1;
            }
            if (textA > textB) {
                return 1;
            }
            return 0;
        }
        catch (err) {
            console.error(err);
            return 0;
        }
    }
    async $onInit() {
        this.hasWritingPermission = await this.PermissionsService.hasPermissions('write', 'desk');
        this.repeatedTitlesErrorMsg = await this.$translate('utils.errorMsg.132');
        this.contenSentSuccessMsg = await this.$translate('utils.successMsg.35');
        if (this.$stateParams.id) {
            this.categoryid = this.$stateParams.id;
            let { items } = await this.RepliesService.getCategoryReplies(this.categoryid);
            items = items.sort(this.sortReplies);
            this.categoryName = items[0].category;
            items.forEach((e) => {
                const id = uuid();
                this.items.push({
                    ...e,
                    documentId: id,
                    component: {
                        document: {
                            id: id,
                            type: e.type,
                            content: JSON.parse(e.document),
                        },
                        position: 'left',
                        editable: this.hasWritingPermission,
                        deletable: this.hasWritingPermission,
                        'on-save': (d) => {
                            this.save();
                        },
                        'on-deleted': (d) => {
                            this.deleteReply(d);
                        },
                    },
                });
            });
        }
        else {
            this.categoryid = uuid();
            const translatedPrefix = await this.$translate('modules.application.detail.attendance.replies.category.reply.defaultTitle');
            this.newCategory = true;
        }
    }
    async save() {
        if (!this.categoryName) {
            this.categoryName = await this.$translate('modules.application.detail.attendance.replies.category.reply.defaultTitle');
        }
        if (this.replyForm.$valid) {
            this.SavingService.startSaving();
            const names = this.items.map((i) => i.name);
            const nameSet = new Set(names);
            if (names.length > nameSet.size && names.length > 1) {
                this.ngToast.danger(this.repeatedTitlesErrorMsg);
                return;
            }
            try {
                if (this.items.length === 0 && !this.newCategory) {
                    await this.RepliesService.delete(this.categoryid);
                }
                else {
                    const replies = this.items.map((x) => ({
                        id: this.categoryid,
                        category: this.categoryName,
                        name: x.name,
                        type: x.component.document.type,
                        document: JSON.stringify(x.component.document.content),
                    }));
                    await this.RepliesService.save(replies, this.categoryid);
                    this.newCategory = false;
                }
            }
            catch (error) {
                this.ngToast.danger(error.message);
            }
            finally {
                this.$timeout(() => {
                    this.SavingService.stopSaving();
                }, 1000);
            }
        }
    }
    deleteReply(document) {
        this.items = this.items.filter((x) => x.documentId != document.id);
        this.save();
    }
    async addNewReply(type) {
        this.createAddReplyTrack();
        if (!this.categoryName) {
            this.categoryName = await this.$translate('modules.application.detail.attendance.replies.category.reply.defaultTitle');
        }
        const contentTemplate = this.BuilderContentService.getContentTemplate(type);
        const name = '';
        if (this.isNameRepeated(name)) {
            this.ngToast.danger(this.repeatedTitlesErrorMsg);
            return;
        }
        const id = uuid();
        const newReply = {
            component: {
                document: {
                    ...contentTemplate,
                    id: id,
                },
                position: 'left',
                editable: true,
                editing: true,
                deletable: true,
                'on-save': (d) => {
                    this.save();
                },
                'on-deleted': (d) => {
                    this.deleteReply(d);
                },
            },
            documentId: id,
            id: this.categoryid,
            category: this.categoryName,
            name: name,
            type: contentTemplate.type,
        };
        this.items = [newReply, ...this.items];
    }
    isNameRepeated(itemName) {
        return this.items.some((i) => i.name === itemName);
    }
    createAddReplyTrack() {
        this.SegmentService.createBotTrack('helpdesk-custom-reply-added', this.application);
    }
}
ReplyController.$inject = ['BuilderContentService', 'RepliesService', 'SegmentService', 'application', '$stateParams', 'ngToast', '$translate', 'SavingService', '$timeout', 'PermissionsService'];
